import { PlaylistStarIcon } from './PlaylistStarIcon';

/**
 * author: Google
 * id 80A0AA10-9B8E-4AAA-BDEA-EDDADB94A7CC
 * name playlist-star
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-star.svg
 * tags
 */
export const PlaylistFavoriteIcon = PlaylistStarIcon;
export default PlaylistFavoriteIcon